import React from "react";
import styles from "./DossierDashboard.module.scss";

const VehicleMix = ({ stats, filters, onToggleBrand }) => {
  if (stats.brands.length === 0) return null;
  return (
    <div className={styles.sect}>
      <div className={styles.sectTitle}>
        <span>Mix véhicules</span>
        <span className={styles.sectTitleRight}>
          VP {stats.vpCount} · VU {stats.vuCount}
        </span>
      </div>
      <div>
        {stats.brands.map((b) =>
          b.name === "Autre" ? (
            /* bucket synthétique des lignes sans marque : non filtrable,
               filterQuotations crashe sur vehicle.brand absent */
            <span key={b.name} className={styles.chip} style={{ cursor: "default" }}>
              {b.name} <span className={styles.chipCount}>{b.qty}</span>
            </span>
          ) : (
            <button
              key={b.name}
              type="button"
              className={`${styles.chip} ${
                filters.brand === b.name.toLowerCase() ? styles.chipActive : ""
              }`}
              onClick={() => onToggleBrand(b.name)}
              title="Filtrer la liste par marque"
            >
              {b.name} <span className={styles.chipCount}>{b.qty}</span>
            </button>
          )
        )}
      </div>
      <div className={styles.note}>clic sur une marque → filtre la liste</div>
    </div>
  );
};

export default VehicleMix;
